module.exports = __webpack_public_path__ + "img/grandville-logo.76c54475.jpg";